/**
 * Mega Menu — hover interactions & image switching
 *
 * - Shows/hides mega menu panels on mouseenter/mouseleave of .has-megamenu items
 * - Switches the right-side image when hovering over [data-menu-trigger] items
 * - All queries are scoped to the individual mega menu panel (no global leaks)
 * - A 150 ms delay on mouseleave prevents accidental closes
 * - A 20 px transparent hover-area bridges the gap between trigger and panel
 */
document.addEventListener('DOMContentLoaded', function () {
  const menuTriggers = document.querySelectorAll('.has-megamenu');
  let hideTimeout = null;

  menuTriggers.forEach(trigger => {
    const megaMenu = trigger.querySelector('[data-mega-menu]');
    if (!megaMenu) return;

    const parentLink = trigger.querySelector(':scope > a');
    const images = megaMenu.querySelectorAll('.mega-menu__image');
    const itemTriggers = megaMenu.querySelectorAll('[data-menu-trigger]');

    /* ---------- show / hide helpers ---------- */
    function show() {
      clearTimeout(hideTimeout);
      // Hide all other mega menus first
      document.querySelectorAll('[data-mega-menu].is-visible').forEach(m => {
        if (m !== megaMenu) {
          m.classList.remove('is-visible');
          const otherLink = m.closest('.has-megamenu')?.querySelector(':scope > a');
          if (otherLink) otherLink.classList.remove('is-active');
        }
      });
      megaMenu.classList.add('is-visible');
      if (parentLink) parentLink.classList.add('is-active');
      // Show first image by default
      showFirstImage();
    }

    function hide() {
      hideTimeout = setTimeout(() => {
        megaMenu.classList.remove('is-visible');
        if (parentLink) parentLink.classList.remove('is-active');
      }, 150);
    }

    /* ---------- image switching ---------- */
    function showFirstImage() {
      images.forEach(img => img.classList.remove('active'));
      if (images.length) images[0].classList.add('active');
    }

    function switchImage(targetId) {
      images.forEach(img => {
        img.classList.toggle('active', img.getAttribute('data-menu-image') === targetId);
      });
    }

    /* ---------- event listeners ---------- */
    // Trigger (the <li>)
    trigger.addEventListener('mouseenter', show);
    trigger.addEventListener('mouseleave', hide);

    // Panel keeps itself open while hovered
    megaMenu.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
    megaMenu.addEventListener('mouseleave', hide);

    // Item hover → switch image
    itemTriggers.forEach(item => {
      item.addEventListener('mouseenter', () => {
        switchImage(item.getAttribute('data-menu-trigger'));
      });
    });
  });
});
